import { render, staticRenderFns } from "./TransactionRR.vue?vue&type=template&id=123be2cc"
import script from "./TransactionRR.vue?vue&type=script&lang=js"
export * from "./TransactionRR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports